window.addEventListener('load', function() {
  // get settings
  
  var slide = document.getElementsByClassName("content-slider-wrapper");

  var default_slides = slide[0].getAttribute("data-default");
  var sevenfive_slides = slide[0].getAttribute("data-seventyfive")
  var one_one_slides = slide[0].getAttribute("data-oneone")
  var one_one_five_slides = slide[0].getAttribute("data-oneonefive")

  // initialize swiper
  var swiper = new Swiper(".wrapperSwiperContent", {
    slidesPerView: default_slides,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      "@0.00": {
        slidesPerView: default_slides,
        spaceBetween: 10,
      },
      "@0.75": {
        slidesPerView: sevenfive_slides,
        spaceBetween: 20,
      },
      "@1.00": {
        slidesPerView: one_one_slides,
        spaceBetween: 40,
      },
      "@1.50": {
        slidesPerView:one_one_five_slides,
        spaceBetween: 50,
      },
    },
  });

});
